export const FORM_CARD_MAX_WIDTH = 920;
